import { render, staticRenderFns } from "./RatingHome.vue?vue&type=template&id=34ecce83"
import script from "./RatingHome.vue?vue&type=script&lang=js"
export * from "./RatingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports